<template>
  <field-frame :field="field" :show-optional="showOptional">
    <template #default="{ inputId, describedBy, requiredEmpty }">
      <div class="flex items-center gap-1.5">
        <span v-if="field.prefix" class="text-q4cl-muted text-sm">{{ $t(field.prefix) }}</span>
        <input
          :id="inputId"
          type="time"
          class="field-input"
          :aria-required="field.required ? 'true' : 'false'"
          :aria-invalid="requiredEmpty ? 'true' : 'false'"
          :aria-describedby="describedBy"
          v-model="field.value"
        />
        <span v-if="field.postfix" class="text-q4cl-muted text-sm">{{ $t(field.postfix) }}</span>
      </div>
    </template>
  </field-frame>
</template>

<script>
import FieldFrame from '@/components/ui/FieldFrame.vue'
export default {
  name: 'TimeField',
  components: {
    'field-frame': FieldFrame
  },
  props: {
    field: { type: Object, required: true },
    showOptional: { type: Boolean, default: false }
  }
};
</script>
